class InlineVideoControl {
	element: HTMLElement;
	videoId: string;
	video: HTMLVideoElement;
	iframe: HTMLIFrameElement;

	constructor(element: HTMLElement) {
		this.element = element;
		this.videoId = element.getAttribute('data-video-id') as string;
		this.video = document.getElementById(this.videoId) as HTMLVideoElement;
		this.iframe = this.video.querySelector('iframe') as HTMLIFrameElement;
	}

	init() {
		const player = new window.Vimeo.Player(this.iframe);
		this.element.addEventListener('click', () => this.togglePlay(player));
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	togglePlay(player: any): void {
		const paused = this.element.getAttribute('data-paused') === 'true';
		if (paused) {
			this.element.setAttribute('data-paused', 'false');
			this.element.setAttribute('aria-label', 'Pause video');
			this.element.setAttribute('aria-pressed', 'false');
			player.play();
		} else {
			this.element.setAttribute('data-paused', 'true');
			this.element.setAttribute('aria-label', 'Play video');
			this.element.setAttribute('aria-pressed', 'true');
			player.pause();
		}
	}
}

document.querySelectorAll('.inline-video-control').forEach((element) => {
	const inlineVideoControl = new InlineVideoControl(element as HTMLElement);
	inlineVideoControl.init();
});
